<template lang="pug">
marketing-list-desktop(v-if="q.platform.is.desktop")
marketing-list-mobile(v-if="q.platform.is.mobile")
</template>

<script>
import {Platform, useMeta, useQuasar} from 'quasar';
import {useStore} from 'vuex';
import {computed} from 'vue';
import {useRouter} from 'vue-router';

import MarketingListMobile from './MarketingListMobile.vue';
import MarketingListDesktop from './MarketingListDesktop.vue';

export default {
    name: 'Marketing',
    components: {
        MarketingListMobile,
        MarketingListDesktop,
    },
    async preFetch({ store, ssrContext }) {
        const platform = process.env.SERVER
            ? Platform.parseSSR(ssrContext)
            : Platform;

        let channel = null;

        if(platform.is.mobile)
            channel = 'app';
        if(platform.is.desktop)
            channel = 'web';

        if (store.getters['advertisement/CACHE']) {
            // кешируем на 15 минут
            if (new Date - store.getters['advertisement/CACHE'] >= 900000)
                await store.dispatch('advertisement/FETCH_ADVERTISMENT', channel);
        } else {
            store.commit('advertisement/SET_CACHE', new Date);
            await store.dispatch('advertisement/FETCH_ADVERTISMENT', channel);
        }        
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        const city = computed(() => store.getters['cityForm/CITY']);

        useMeta({
            title: `Акции и скидки | Интернет-аптека eTabl.ru (партнер Таблеточка) | ${city?.value?.name ? city.value.name : 'Белгород'}`,
            meta: {
                description: { name:'description', content:`Скидки и акции в онлайн-аптеке eTabl.ru (партнер Таблеточка) в ${city?.value?.name ? city.value.name : 'Белгород'}. Персональные предложения для клиентов программы лояльности.`},
                og_locale: {property: 'og:locale', content: 'ru_RU'},
                og_type: {property: 'og:type', content: 'website'},
                og_site_name: {property: 'og:site_name', content: 'eTabl.ru'},
                og_title: {
                    property: 'og:title',
                    content: `Акции и скидки | Интернет-аптека eTabl.ru (партнер Таблеточка) | ${city?.value?.name ? city.value.name : 'Белгород'}`,
                },
                og_description: {
                    property: 'og:description',
                    content: `Скидки и акции в онлайн-аптеке eTabl.ru (партнер Таблеточка) в ${city?.value?.name ? city.value.name : 'Белгород'}. Персональные предложения для клиентов программы лояльности.`,
                },
                og_url: {property: 'og:url', content: `https://${process.env.APP_SERVICE_HOSTNAME}${router.currentRoute.value.fullPath}`},
                og_image: { property: 'og:image', content: 'https://etabl.ru/logo.svg' },
            },
        });

        return {
            q: useQuasar(),
        };
    },
};
</script>
